<template>
  <div class="yzm-texttimeselect" :style="{ ...marginStyle }">
    <div class="flex flex-item-center" v-if="item.setting?.layoutType == 0">
      <div :style="{ ...textStyle, marginRight: '8px' }">
        {{ item.setting?.title }}
      </div>
      <y-time-select class="flex-1" :item="item" :is-margin="false" />
    </div>
    <div class="flex flex-item-center" v-if="item.setting?.layoutType == 1">
      <y-time-select class="flex-1" :item="item" :is-margin="false" />
      <div :style="{ ...textStyle, marginLeft: '8px' }">{{ item.setting?.title }}</div>
    </div>
    <div class="flex flex-column" v-if="item.setting?.layoutType == 2">
      <y-time-select :item="item" :is-margin="false" />
      <div :style="{ ...textStyle, marginTop: '8px' }">{{ item.setting?.title }}</div>
    </div>
    <div class="flex flex-column" v-if="item.setting?.layoutType == 3">
      <div :style="{ ...textStyle, marginBottom: '8px' }">{{ item.setting?.title }}</div>
      <y-time-select :item="item" :is-margin="false" />
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed, onMounted, defineEmits } from 'vue'
import { defaultProps } from './defaultProps'
import yTimeSelect from './yTimeSelect.vue'
const props = defineProps({
  ...defaultProps
})
const marginStyle = computed(() => {
  let item = props.item.setting
  return {
    marginTop: `${item.marginTop}px`,
    marginBottom: `${item.marginBottom}px`,
    marginLeft: `${item.marginLeft}px`,
    marginRight: `${item.marginRight}px`
  }
})
const textStyle = computed(() => {
  let item = props.item.setting
  return {
    fontSize: `${item.fontSize}px`,
    color: item.color,
    fontStyle: item?.fontStyle,
    fontWeight: item?.fontWeight
  }
})
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-texttimeselect {
}
</style>
